import { render } from "./InvoicesComponent.vue?vue&type=template&id=14ea3a6c"
import script from "./InvoicesComponent.vue?vue&type=script&lang=js"
export * from "./InvoicesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__